import { render, staticRenderFns } from "./TripBoard.vue?vue&type=template&id=3ede29b8&scoped=true"
import script from "./TripBoard.vue?vue&type=script&lang=js"
export * from "./TripBoard.vue?vue&type=script&lang=js"
import style0 from "./TripBoard.vue?vue&type=style&index=0&id=3ede29b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ede29b8",
  null
  
)

export default component.exports